import request from '@/utils/request'

// 查询Api统计(当前套餐应用每月API额度、本月消耗API数、购买剩余api、半小时并发数(实时))
export function getApi(id) {
  return request({
    url: `/backend/analysis/${id}/api`,
    method: 'get'
  })
}

export function getApiStat(id, mapType, timeType) {
  return request({
    url: `/backend/analysis/${id}/api_stat`,
    method: 'get',
    params: {
      mapType, // Api类型:-1:全部;1:增加;2:删除;3:改;4:查;5:用户;6:文件;7:图片;8:云端代码; 9:推送 0:其他
      timeType // 时间类型:1最近一周;2最近一个月;3最近三个月;
    }
  })
}

// 查询邮件统计(剩余邮件、累计发送量)
export function getEmail(id) {
  return request({
    url: `/backend/analysis/${id}/email`,
    method: 'get'
  })
}

export function getEmailStat(id, type, email, limit, offset) {
  return request({
    url: `/backend/analysis/${id}/email_stat`,
    method: 'get',
    params: {
      type, // 状态:-1全部;0失败;1成功;
      email, // 邮箱
      limit,
      offset
    }
  })
}

// 查询流量统计(账户剩余流量、购买剩余流量、应用本月使用流量)
export function getFlow(id) {
  return request({
    url: `/backend/analysis/${id}/flow`,
    method: 'get'
  })
}

export function getFlowStat(id, timeType) {
  return request({
    url: `/backend/analysis/${id}/flow_stat`,
    method: 'get',
    params: {
      timeType // 时间类型:1最近一周;2最近一个月;3最近三个月;
    }
  })
}

// 查询存储统计(账户剩余容量、应用存储使用量)
export function getStorage(id) {
  return request({
    url: `/backend/analysis/${id}/storage`,
    method: 'get'
  })
}

export function getStorageStat(id, timeType) {
  return request({
    url: `/backend/analysis/${id}/storage_stat`,
    method: 'get',
    params: {
      timeType // 时间类型:1最近一周;2最近一个月;3最近三个月;
    }
  })
}

export function getToken(id) {
  return request({
    url: `/backend/analysis/${id}/token`,
    method: 'get'
  })
}

export function getTokenStat(id, timeType, model, source) {
  const params = { timeType }
  if (model) params.model = model
  if (source) params.source = source
  return request({
    url: `/backend/analysis/${id}/token_stat`,
    method: 'get',
    params
  })
}

export function getModelPricing() {
  return request({
    url: '/backend/analysis/model_pricing',
    method: 'get'
  })
}

export function getApiList(id, query, limit, offset) {
  return request({
    url: `/backend/analysis/${id}/api_today`,
    method: 'get',
    params: {
      query,
      limit,
      offset
    }
  })
}
